<template>
<!-- w3-animate-zoom -->
    <base-dialog @close="close" :open="show" newClass="w3-modal-content w3-card-4 ">
        <template #default>
            <div style="max-width:600px">
                <div class="w3-margin-top"></div>
                <div class="container-fluid w3-margin-top"> 
                    <div class="row w3-margin-top">
                        <div class="col-sm-3">
                            <img :src="item_image" alt="Avatar" style="width:100%">
                        </div>
                        <div class="col-sm-9 w3-margin-top">
                            You have added {{quantity}} <strong>{{item_name}}</strong> to your cart.
                            <div class="w3-margin-top">
                                <strong>Cart Subtotal ({{totalQtys}} items): {{toUSD(totals[0].ordertotal)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #actions>
            <div class="w3-container w3-border-top w3-padding-16 w3-light-grey buttons">
                <button @click="close" type="button" class="w3-button w3-red w3-left"><strong>Keep Shopping</strong></button>
                <button @click="goToCart" class="w3-button w3-green w3-right"><strong>Go to Cart</strong></button>
            </div>
        </template>
    </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import Price from '../../../mixins/price.js';

export default {
    mixins: [Price],
    data () {
        return {
            totalQty: 0,
        };
    },
    props : {
        quantity: {
            type: Number
        },
        item_name: {
            type: String
        },
        item_image: {
            type: String
        }
    },
    computed: {
        ...mapGetters("cart", [
            "cart",
            "totals",
            'kits'
        ]),
        totalQtys() {
            let totalquantity = 0;
            for (let x in this.cart) {
                totalquantity += parseInt(this.cart[x].quantity);
            }

            for (let x in this.kits) {
                totalquantity += parseInt(this.kits[x].quantity);
            }
            return totalquantity;
        }
    },
    methods: {
        goToCart() {
            this.$emit('close');
            this.$router.push('/cart')
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>

<style>
    dialog.w3-modal-content{
        padding: 0px !important;
    }

</style>

<style scoped>
    dialog .actions .w3-container{
        width: 100%;
    }

    .w3-left {
        float: left;
    }
</style>